import { useLocation } from 'react-router-dom';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import { localizarRota } from '../../utils/modulos';
import { secaoPorRota } from '../parametros/secoes';

// Migalhas do topo da tela: "Módulo › Subgrupo › Tela" (o subgrupo só aparece
// quando a tela está dentro de um). Reforça a separação por módulo e orienta o
// usuário quando a barra lateral está recolhida. Fica escondido em telas sem
// módulo mapeado (ex.: início sem cabeçalho).
const Migalhas = () => {
    const { pathname } = useLocation();
    const { modulo, grupo, item } = localizarRota(pathname);

    if (!item) return null;

    // A central de parâmetros tem navegação própria dentro da tela: sem esta
    // migalha extra, todas as seções apareceriam como "Parâmetros" e a trilha
    // pararia de dizer onde a pessoa está.
    const secao = item.rota === '/parametros'
        ? secaoPorRota(pathname.replace('/parametros/', ''))
        : null;

    const temModulo = modulo?.titulo;

    return (
        <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            sx={{ mb: 2 }}
            aria-label="trilha de navegação"
        >
            {temModulo && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: modulo.cor }}>
                    {modulo.icone}
                    <Typography variant="body2" fontWeight={600} color="inherit">
                        {modulo.titulo}
                    </Typography>
                </Box>
            )}
            {grupo && (
                <Typography variant="body2" color="text.secondary" fontWeight={600}>
                    {grupo.titulo}
                </Typography>
            )}
            <Typography
                variant="body2"
                color={secao ? 'text.secondary' : 'text.primary'}
                fontWeight={600}
            >
                {item.titulo}
            </Typography>
            {secao && (
                <Typography variant="body2" color="text.primary" fontWeight={600}>
                    {secao.titulo}
                </Typography>
            )}
        </Breadcrumbs>
    );
};

export default Migalhas;
